import script from "./ClientTasksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientTasksPage.vue?vue&type=script&setup=true&lang=js"

import "./ClientTasksPage.vue?vue&type=style&index=0&id=6182e235&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6182e235"]])

export default __exports__